import { getSources } from '@shoflo/studio-redux/actions';

export default () => {
  return dispatch => {
    dispatch(getSources());
  };
};
